















































































import { computed, defineComponent } from '@vue/composition-api';
import { useFormat } from 'vivat';
import PrettyCheck from 'pretty-checkbox-vue/check';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';

const LongDeliveryObject = defineComponent({
  components: {
    PrettyCheck,
  },
  props: {
    order: { default: 1 },
    delivery: {
      default() {
        return {
          id: -1,
          customerName: 'Idea Vivat',
          contactName: 'Firstname Lastname',
          contactTelephone: '09-XXXX-XXXX',
          orderNumber: 'UPA08XX',
          address: {
            address: 'XXXX/116',
            province: {
              id: -1,
              nameInThai: 'เมลเบิร์น',
              nameInEnglish: 'Melbourne',
            },
            district: {
              id: -1,
              nameInThai: 'ราชเทวี',
              nameInEnglish: 'Ratchatheveeee',
            },
            subdistrict: {
              id: -1,
              nameInThai: 'พญาไท',
              nameInEnglish: 'Phayathai',
            },
            zipcode: '32901',
            telephone: '09-XXXX-XXXX',
          },
          deliveryArea: 'EA1W0001',
          remarks: '',
          status: 'PENDING',
          urgentLevel: '',
          packages: [{
            name: '',
            width: '',
            length: '',
            height: '',
            count: '',
            weight: '',
            unitsPerCount: '',
          }],
          area: {
            name: 'IDV',
          },
          targetDate: '',
        };
      },
    },
    overlayNumber: {},
    isSelect: { default: false },
    isLatest: { default: true },
  },
  setup(props: any) {
    const computedAddress = computed(() => `${props.delivery.address.address} ${props.delivery.address.province?.nameInThai} ${props.delivery.address.district?.nameInThai ? props.delivery.address.district?.nameInThai : ''} ${props.delivery.address.subdistrict?.nameInThai ? props.delivery.address.subdistrict?.nameInThai : ''}`);
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    function formatToCurrency(number: string) {
      return useFormat.number(number).currency();
    }
    const toDate = (date: string) => useFormat.date(date).displayShortThaiDate();

    const { distanceTypeToChipClass, translateDistanceType } = useDeliveryAreaCode();

    return {
      toDate,
      computedAddress,
      formatToCurrency,
      toCurrency,
      distanceTypeToChipClass,
      translateDistanceType,
    };
  },
});

export default LongDeliveryObject;
